// oxlint-disable-next-line cian-eslint-compat/no-extraneous-dependencies
import { ESaleType } from 'packages/api-models/common/json_query';
import { getTermsValue, setTerms } from './helpers';
import { TJsonQuery, NonEmptyArray, FOfferType } from './types';
import { offerTypeFromJsonQuery } from './utils';
import { uniq } from 'ramda';

export const setSaleTypes = (jsonQuery: TJsonQuery) => (nextSaleTypes: NonEmptyArray<ESaleType> | null) => {
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  let resultSaleTypes: NonEmptyArray<ESaleType> | null = nextSaleTypes;

  if (offerType === FOfferType.Flat) {
    const prevSaleTypes = getTermsValue('sost_type')(jsonQuery);
    const mergedSaleTypes = [prevSaleTypes, nextSaleTypes].flat().filter(Boolean) as ESaleType[];
    const uniqueSaleTypes = uniq(mergedSaleTypes);

    resultSaleTypes = uniqueSaleTypes.length ? (uniqueSaleTypes as NonEmptyArray<ESaleType>) : null;
  }

  return setTerms('sost_type')(jsonQuery)(resultSaleTypes);
};
